import React from "react";
import { Helmet } from "react-helmet";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import DashboardLayout from "@/components/DashboardLayout";
import PageCallToAction from "@/components/PageCallToAction";

const JobListing = ({
  title,
  department,
  location,
  type,
}: {
  title: string;
  department: string;
  location: string;
  type: string;
}) => {
  return (
    <Card className="mb-4">
      <CardHeader className="pb-2">
        <CardTitle>{title}</CardTitle>
        <CardDescription>{department}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap justify-between items-center">
          <div className="flex gap-4 text-sm text-muted-foreground">
            <span>{location}</span>
            <span>{type}</span>
          </div>
          <Button className="mt-2 sm:mt-0">Apply Now</Button>
        </div>
      </CardContent>
    </Card>
  );
};

const Careers = () => {
  const openPositions = [
    {
      title: "Senior Machine Learning Engineer",
      department: "Engineering",
      location: "San Francisco, CA",
      type: "Full-time",
    },
    {
      title: "Product Designer",
      department: "Design",
      location: "Remote",
      type: "Full-time",
    },
    {
      title: "Full Stack Developer",
      department: "Engineering",
      location: "New York, NY",
      type: "Full-time",
    },
    {
      title: "DevOps Engineer",
      department: "Operations",
      location: "Remote",
      type: "Full-time",
    },
    {
      title: "Technical Writer",
      department: "Documentation",
      location: "Remote",
      type: "Part-time",
    },
  ];

  return (
    <DashboardLayout>
      <div className="container mx-auto py-12 px-4">
        <Helmet>
          <title>Careers | OpenPipe</title>
        </Helmet>

        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">Join Our Team</h1>
            <p className="text-lg text-muted-foreground">
              Help us build the future of AI and machine learning. We're looking
              for talented individuals to join our growing team.
            </p>
          </div>

          <h2 className="text-2xl font-bold mb-6">Open Positions</h2>

          <div className="space-y-4">
            {openPositions.map((job, index) => (
              <JobListing
                key={index}
                title={job.title}
                department={job.department}
                location={job.location}
                type={job.type}
              />
            ))}
          </div>

          <Card className="mt-12">
            <CardHeader>
              <CardTitle>Don't see a role that fits?</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="mb-4">
                We're always looking for talented individuals to join our team.
                Send us your resume and tell us how you can contribute.
              </p>
              <Button variant="outline">Send Open Application</Button>
            </CardContent>
          </Card>

          <div className="mt-12">
            <PageCallToAction />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Careers;
